import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const {
  Form,
  FormGroup,
  FormLabel,
  FormControl,
  Button,
} = require('react-bootstrap');

const SignUp = () => {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');

  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    if (confirmPassword !== password) {
      toast.error('Passwords do not match!');

      return;
    }
    try {
      await axios.post(
        'https://jap-vocab-n2.herokuapp.com/api/v1/users/signup',
        {
          name: name,
          email: email,
          password: password,
        }
      );
      navigate('/login');
    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <div
      className="flex"
      style={{
        flexDirection: 'column',
        gap: '2rem',
        marginTop: '20px',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h4>
        Subscribing allows you to save your score. It has no other advantages
      </h4>
      <Form onSubmit={submitHandler}>
        <FormGroup>
          <FormLabel>Name: </FormLabel>
          <FormControl
            type="text"
            required
            placeholder="pick up a name (short)"
            onChange={(e) => setName(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <FormLabel>Email: </FormLabel>
          <FormControl
            type="text"
            required
            placeholder="any valid email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Password: </FormLabel>
          <FormControl
            type="password"
            required
            placeholder="anything"
            onChange={(e) => setPassword(e.target.value)}
          />
        </FormGroup>
        <FormGroup>
          <FormLabel>Confirm Password: </FormLabel>
          <FormControl
            type="password"
            required
            placeholder="anything"
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </FormGroup>
        <Button type="submit" style={{ width: '100%', marginTop: '20px' }}>
          Sign Up
        </Button>
      </Form>
    </div>
  );
};

export default SignUp;
